import type {
  AdjustmentFilterKeys,
  AdjustmentDocument,
  AdjustmentExistingDocument,
  AutoCompleteAccountExisting,
  AutoCompleteAccountNew,
  AutocompleteAccountReponseStruct,
  AutocompleteAccountReponseStructNew,
  EditAdjustmentResponse,
  NewAdjustmentResponse,
  SubAdjustmentRow,
} from './types'
import type {
  AdjustmentModalNewPayload,
  AdjustmentModalEditPayload,
  AdjustmentModalBuildPayload,
  AdjustmentModalPayload,
} from '@app/types'

export function isAutocompleteAccountNew(
  account: AutoCompleteAccountExisting | AutoCompleteAccountNew
): account is AutoCompleteAccountNew {
  return account.id === null
}

export function isAdjustmentFilterKey(
  key: string
): key is AdjustmentFilterKeys {
  return ['categoryIds', 'copyTypes', 'tagIds'].indexOf(key) >= 0
}

export function isExistingAttachment(
  attachment: AdjustmentDocument
): attachment is AdjustmentExistingDocument {
  return !attachment.new
}

export function isExistingAutocompleteAccountReponse(
  struct: AutocompleteAccountReponseStruct | AutocompleteAccountReponseStructNew
): struct is AutocompleteAccountReponseStruct {
  return struct.type === 'existing'
}

export function isErrorWithBody(error: unknown): error is {
  body: {
    errors: string[]
  }
} {
  return (
    typeof error === 'object' &&
    error !== null &&
    'body' in error &&
    error.body !== null &&
    typeof error.body === 'object' &&
    'errors' in error.body
  )
}

export function isNewPayload(
  payload: AdjustmentModalPayload
): payload is AdjustmentModalNewPayload {
  return payload.mode === 'new'
}

export function isEditPayload(
  payload: AdjustmentModalPayload
): payload is AdjustmentModalEditPayload {
  return payload.mode === 'edit'
}

export function isBuildPayload(
  payload: AdjustmentModalPayload
): payload is AdjustmentModalBuildPayload {
  return payload.mode === 'build'
}

export function isEditAdjustmentResponse(
  response: EditAdjustmentResponse | NewAdjustmentResponse
): response is EditAdjustmentResponse {
  return response.mode === 'edit'
}

export function isMathExpressionColumn(
  key: keyof SubAdjustmentRow
): key is 'valueDebit' | 'valueCredit' {
  return ['valueDebit', 'valueCredit'].includes(key)
}
